<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="success" plain @click="onExport">导出</el-button>
        <el-button size="mini" type="success" plain @click="onImport" icon="el-icon-plus">导入</el-button>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/purchase/business/pudocgoods/list";
import importDialog from "@/components/purchase/business/pudocgoods/importDialog";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
    importDialog,
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
    }
  },
  methods: {
    onImport() {
      this.$refs.importDialog.open();
    },
    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$refs.list.onExport();
        })
        .catch(() => {});
    },
  },
};
</script>